import request from '@/utils/request2'

// 列表(主数据列表)
export function loadWeChatGroupMessageListDataApi(data) {
  return request({
    url: 'tms-web/weChatGroupMessage/listByPage',
    method: 'post',
    data
  })
}

// 导出
export function exportWeChatGroupMessageListDataApi(data) {
  return request({
    url: 'tms-web/weChatGroupMessage/exportByPage',
    method: 'post',
    data
  })
}

// 查看
export function viewWeChatGroupMessageApi(data) {
  return request({
    url: 'tms-web/weChatGroupMessage/view',
    method: 'post',
    data
  })
}
